import {ElementProps, FloatingContext, ReferenceType} from '@floating-ui/react';

import {isNonInteractiveTarget} from './interactionGuards';

export const useConditionalClick = <RT extends ReferenceType = ReferenceType>({
  open,
  onOpenChange,
  dataRef,
  refs,
}: FloatingContext<RT>): ElementProps => {
  const isButton = () => {
    return (
      refs.reference.current instanceof window.HTMLElement &&
      refs.reference.current.tagName === 'BUTTON'
    );
  };

  const shouldIgnoreInteraction = (target: unknown) =>
    isNonInteractiveTarget(target);

  return {
    reference: {
      onClick(event) {
        if (shouldIgnoreInteraction(event.target)) {
          return;
        }

        if (open) {
          if (dataRef.current.openEvent?.type === 'click') {
            onOpenChange(false);
          }
        } else {
          onOpenChange(true);
        }

        event.stopPropagation();
        dataRef.current.openEvent = event.nativeEvent;
      },
      onKeyDown(event) {
        if (shouldIgnoreInteraction(event.target)) {
          return;
        }

        if (isButton()) {
          return;
        }

        if (event.key === ' ') {
          // Prevent scrolling
          event.preventDefault();
        }

        if (event.key === 'Enter') {
          if (open) {
            onOpenChange(false);
          } else {
            onOpenChange(true);
          }
        }
      },
      onKeyUp(event) {
        if (shouldIgnoreInteraction(event.target)) {
          return;
        }

        if (isButton()) {
          return;
        }

        if (event.key === ' ') {
          if (open) {
            onOpenChange(false);
          } else {
            onOpenChange(true);
          }
        }
      },
    },
  };
};
